export class OnlineApplication {
    public ID: Number;
    public Reference: String;
    public Name: String;
    public Surname: String;
    public Gender: String;
    public DateOfBirth: Date;
    public IDNumber: String;
    public Nationality: String;
    public Religion: String;
    public PreviousSchool: String;
    public StudentEmailAddress: String;
    public StudentMobileNumber: String;
    public ClassGroupID: Number;
    public Year: String;
    public StudentType: String;
    public Address: String;
    public NextOfKin: String;
    public Relationship: String;
    public MobileNumber: String;
    public EmailAddress: String;
    public MotherFullName: String;
    public MotherMobileNumber: String;
    public MotherEmailAddress: String;
    public FatherFullName: String;
    public FatherMobileNumber: String;
    public FatherEmailAddress: String;
    public PrimaryContact: String;
    public StudentNumber: String;
    public ClassID: Number;
    public ClassYear: String;
    public Status: String;
    public Comment: String;
    public DateCreated: Date;
    public ProcessedBy: String;
    public DateProcessed: Date;
}